<template>
  <div>
    <LabelReset
      v-if="label || slots.label"
      :initialValue="initialValue"
      v-model="modelValue"
      :forInput="inputId || name"
    >
      <slot name="label">{{ label }}</slot>
    </LabelReset>
    <component
      :is="type === 'password' ? Password : InputText"
      class="w-full [&_input]:w-full"
      :id="inputId || name"
      :name="name"
      :class="[{ '!border-fg-error': isInvalid }, inputClasses]"
      v-model="modelValue"
      :type="type"
      :feedback="false"
      :placeholder="placeholder"
      toggleMask
    />
    <Message
      v-if="helperText || slots.helperText"
      id="helper-text-message"
      class="mt-1"
      severity="secondary"
      size="small"
      variant="simple"
    >
      <slot name="helperText">{{ helperText }}</slot>
    </Message>
    <Message
      v-if="errors && errors.length"
      id="error-message"
      severity="error"
      size="small"
      variant="simple"
      :class="{ '!text-fg-error': isInvalid }"
    >
      {{ errors[0] }}
    </Message>
  </div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext'
import Message from 'primevue/message'
import Password from 'primevue/password'
import { computed, useSlots } from 'vue'

import LabelReset from '@/common/components/molecules/LabelReset.vue'

interface Props {
  helperText?: string
  initialValue?: string
  name?: string
  label?: string
  inputId?: string
  errors?: string[]
  type?: string
  placeholder?: string
  inputClasses?: string
}
const props = withDefaults(defineProps<Props>(), {
  helperText: undefined,
  initialValue: undefined,
  label: undefined,
  name: undefined,
  inputId: undefined,
  errors: undefined,
  type: 'text',
  placeholder: undefined,
  inputClasses: undefined,
})

const modelValue = defineModel<string>({ required: false, default: undefined })
const slots = useSlots()
const isInvalid = computed<boolean>(() => Boolean(props.errors && props.errors.length > 0))
</script>
